import { YieldFetcher } from '../../types'

const EZETH_URL = 'https://app.renzoprotocol.com/api/stats?chainId=1'

export const ezethFetcher: YieldFetcher = {
  label: 'EZETH',
  fetch: async () => {
    const res = await fetch(EZETH_URL).then((r) => r.json())
    return { EZETH: Number(res.data.apr.data.rate) }
  },
}
